import { GetStaticProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Error from 'next/error';

import MarketplacePage from '@/containers/MarketplacePage';

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const errorCode: null | number = null;


  return {
    props: {
      hideFooter: true,
      ...(await serverSideTranslations(locale, [
        'common',
        'limitedCollection',
      ])),
      errorCode,
    },
    revalidate: 60,
  };
};

type Props = {
  errorCode: number | null;
};

const Marketplace: NextPage<Props> = (props: Props) => {
  if (props.errorCode) {
    return <Error statusCode={props.errorCode || 500} />;
  }

  return <MarketplacePage />;
};

export default Marketplace;
